import useSWR from 'swr';
import { TokenIcons } from '../../../assets/icons';
import { EnabledChains, Tokens } from '../../../config/constants';
import { TradePair } from '../../../context/chart/chartTypes';
import { verifyChainConfig } from '../../../helpers';
import { useWeb3React } from '@web3-react/core';
import { config } from '../../../config/config';
// import { ITradePair__factory } from '../../../config/contracts/typechain';
// import { formatUnits } from 'ethers/lib/utils';
import useTokenDetails from '../useTokenDetails';

const pools: Omit<TradePair, 'address' | 'collateralDecimals'>[] = [
    {
        asset: {
            name: 'Bitcoin',
            symbol: Tokens.BTC,
            decimals: 18,
        },
        name: 'BTC / USD',
        icons: [TokenIcons.BTC],
        chartSymbol: 'BTCUSDC',
        minLeverage: '1.1',
        maxLeverage: '100',
        decimalFormatting: 2,
    },
    {
        asset: {
            name: 'Ether',
            symbol: Tokens.ETH,
            decimals: 18,
        },
        name: 'ETH / USD',
        icons: [TokenIcons.ETH],
        chartSymbol: 'ETHUSDC',
        minLeverage: '1.1',
        maxLeverage: '100',
        decimalFormatting: 2,
    },
    {
        asset: {
            name: 'ChainLink',
            symbol: Tokens.LINK,
            decimals: 18,
        },
        name: 'LINK / USD',
        icons: [TokenIcons.LINK],
        chartSymbol: 'LINKUSDC',
        minLeverage: '1.1',
        maxLeverage: '100',
        decimalFormatting: 4,
    },
    {
        asset: {
            name: 'BNB',
            symbol: Tokens.BNB,
            decimals: 18,
        },
        name: 'BNB / USD',
        icons: [TokenIcons.BNB],
        chartSymbol: 'BNBUSDC',
        minLeverage: '1.1',
        maxLeverage: '100',
        decimalFormatting: 2,
    },
    {
        asset: {
            name: 'Ripple',
            symbol: Tokens.XRP,
            decimals: 18,
        },
        name: 'XRP / USD',
        icons: [TokenIcons.XRP],
        chartSymbol: 'XRPUSDC',
        minLeverage: '1.1',
        maxLeverage: '100',
        decimalFormatting: 4,
    },
    {
        asset: {
            name: 'Cardano',
            symbol: Tokens.ADA,
            decimals: 18,
        },
        name: 'ADA / USD',
        icons: [TokenIcons.ADA],
        chartSymbol: 'ADAUSDC',
        minLeverage: '1.1',
        maxLeverage: '100',
        decimalFormatting: 4,
    },
    {
        asset: {
            name: 'Polygon',
            symbol: Tokens.MATIC,
            decimals: 18,
        },
        name: 'MATIC / USD',
        icons: [TokenIcons.MATIC],
        chartSymbol: 'MATICUSDC',
        minLeverage: '1.1',
        maxLeverage: '100',
        decimalFormatting: 4,
    },
    {
        asset: {
            name: 'Polkadot',
            symbol: Tokens.DOT,
            decimals: 18,
        },
        name: 'DOT / USD',
        icons: [TokenIcons.DOT],
        chartSymbol: 'DOTUSDC',
        minLeverage: '1.1',
        maxLeverage: '100',
        decimalFormatting: 4,
    },
    {
        asset: {
            name: 'Arbitrum',
            symbol: Tokens.ARB,
            decimals: 18,
        },
        name: 'ARB / USD',
        icons: [TokenIcons.ARB],
        chartSymbol: 'ARBUSDC',
        minLeverage: '1.1',
        maxLeverage: '100',
        decimalFormatting: 4,
    },
    {
        asset: {
            name: 'Dogecoin',
            symbol: Tokens.DOGE,
            decimals: 8,
        },
        name: 'DOGE / USD',
        icons: [TokenIcons.DOGE],
        chartSymbol: 'DOGEUSDC',
        minLeverage: '1.1',
        maxLeverage: '100',
        decimalFormatting: 4,
    },
    {
        asset: {
            name: 'Uniswap',
            symbol: Tokens.UNI,
            decimals: 18,
        },
        name: 'UNI / USD',
        icons: [TokenIcons.UNI],
        chartSymbol: 'UNIUSDC',
        minLeverage: '1.1',
        maxLeverage: '100',
        decimalFormatting: 4,
    },
];

const useTradePools = () => {
    const { library, chainId } = useWeb3React();

    const {
        // decimals,
        // error: tokenDetailsError,
    } = useTokenDetails(config.addresses[chainId as EnabledChains[number]]?.collateral);

    const { data, error, mutate } = useSWR<TradePair[] | undefined, Error>(
        library && chainId ? ['tradePools', library, chainId] : null,
        async (_, library, chainId, decimals) => {
            if (!verifyChainConfig(chainId)) return;

            const tradePools = await Promise.all(
                pools.map(async (pool) => {
                    const poolAddress =
                        config.addresses[chainId].tradePair[pool.asset.symbol]!;

                    // const tradePairContract = ITradePair__factory.connect(
                    //     poolAddress,
                    //     library
                    // );

                    // const minLeverage = await tradePairContract.minLeverage();
                    // const maxLeverage = await tradePairContract.maxLeverage();

                    return {
                        ...pool,
                        address: poolAddress,
                        minLeverage: '0',
                        maxLeverage: '100',
                        // minLeverage: formatUnits(minLeverage, decimals),
                        // maxLeverage: formatUnits(maxLeverage, decimals),
                        collateralDecimals: decimals,
                    };
                })
            );

            return tradePools as TradePair[];
        }
    );

    return {
        tradePools: data,
        isLoading: !error && !data,
        // && !tokenDetailsError,
        error: error,
        // || tokenDetailsError,
        mutate,
    };
};

export default useTradePools;
